__turbopack_context__.v({
  "card": "check-input-card-module-scss-module__gE7ggq__card",
  "image-wrapper": "check-input-card-module-scss-module__gE7ggq__image-wrapper",
  "input-wrapper": "check-input-card-module-scss-module__gE7ggq__input-wrapper",
  "placeholder": "check-input-card-module-scss-module__gE7ggq__placeholder",
});
